/**
 * -----------------------------------------------------------------------------
 * It renders a man unlocking a padlock illustration.
 * TODO: remove the inline colors later.
 */
export function ManUnlockingIllustrationSVG() {
  return (
    <svg fill="none" height="200" viewBox="0 0 185 200" width="185">
      <g clipPath="url(#a)">
        <path
          d="M163.608 171.538h11.217m-165.652 0h151.68"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M40.014 171.556h-1.041c3.512-22.161 18.519-41.238 39.235-49.838a.516.516 0 0 1 .396.951c-20.338 8.445-35.085 27.15-38.59 48.89v-.003Z"
          fill="#16A34A"
        />
        <path
          d="M54.073 156.083c-5.435-3.17-11.928 4.646-11.772 4.858a61.39 61.39 0 0 0-1.076 3.069c.892-1.146 4.272-2.267 9.003-2 4.703.094 9.134-3.101 3.845-5.931v.004Zm-16.1-8.424c-5.442-2.917-6.476 5.535-2.704 8.775 3.589 3.295 5.699 6.118 5.87 7.552a63.65 63.65 0 0 1 .87-3.146c-.243.007 1.017-10.226-4.033-13.177l-.003-.004Zm21.108.545c-4.827-4.028-12.49 2.493-12.372 2.716a65.93 65.93 0 0 0-1.562 2.798c1.065-.955 4.57-1.458 9.183-.375 4.61.91 9.492-1.455 4.752-5.135v-.004Zm-14.458-11.007c-4.876-3.785-7.274 4.309-4.095 8.111 2.991 3.837 4.602 6.948 4.536 8.369.434-.983.888-1.952 1.37-2.907-.239-.02 2.67-9.802-1.811-13.573Zm20.684 4.108c-4.092-4.771-12.71.344-12.626.576a62.915 62.915 0 0 0-1.996 2.476c1.204-.75 4.734-.646 9.093 1.198 4.384 1.681 9.583.174 5.526-4.25h.003Zm-12.411-13.271c-4.175-4.546-7.878 3.017-5.369 7.288 2.311 4.274 3.387 7.601 3.089 8.979a63.836 63.836 0 0 1 1.825-2.614c-.236-.056 4.241-9.181.459-13.657l-.004.004Zm19.718 7.503c-3.242-5.385-12.606-1.771-12.557-1.535-.809.681-1.6 1.382-2.378 2.105 1.309-.539 4.773.159 8.76 2.705 4.037 2.392 9.427 1.767 6.171-3.275h.004ZM62.598 120.37c-3.36-5.18-8.295 1.674-6.532 6.302 1.565 4.605 2.072 8.063 1.548 9.369a64.313 64.313 0 0 1 2.232-2.271c-.233-.09 5.723-8.354 2.748-13.403l.004.003Zm18.252 10.674c-2.295-5.858-12.207-3.833-12.19-3.59a62.99 62.99 0 0 0-2.707 1.684c1.385-.313 4.69.948 8.201 4.125 3.582 3.031 9.045 3.302 6.692-2.215l.003-.004Zm-7.31-16.639c-2.443-5.674-8.53.285-7.573 5.149.76 4.809.674 8.31-.062 9.511a67.757 67.757 0 0 1 2.592-1.872c-.222-.125 7.108-7.309 5.043-12.788Zm.405 9.813c-.156-.059 6.536-6.369 11.308-7.973 4.64-1.715 7.024 1.361 6.563 3.472-.434 2.129-3.714 3.191-6.594 3.494-2.87.069-11.26.854-11.277 1.007Z"
          fill="#16A34A"
        />
        <path
          d="M73.87 124.554s-.029-.007-.043-.013a.356.356 0 0 1-.225-.334c0-.01 0-.021.007-.035.01-.093.02-.166.135-.232 1.02-1.361 7.302-6.643 11.401-8.021 2.284-.844 4.394-.639 5.779.566.996.868 1.478 2.166 1.228 3.305-.586 2.882-5.424 3.608-6.892 3.761-2.798.069-10.433.788-11.145.965a.347.347 0 0 1-.242.035l-.004.003Zm14.985-8.354c-.854-.198-1.995-.181-3.48.368-3.766 1.267-8.68 5.452-10.461 7.132.715-.09 1.832-.198 3.571-.357 2.246-.205 5.192-.438 6.73-.473 2.759-.288 5.872-1.288 6.264-3.218.198-.903-.198-1.942-1.007-2.646a3.677 3.677 0 0 0-1.617-.806Zm-54.249 55.356h-1.249c-11.342-16.598-14.49-37.935-8.104-57.2a.513.513 0 1 1 .975.323c-6.358 19.185-3.113 40.456 8.378 56.873v.004Z"
          fill="#16A34A"
        />
        <path
          d="M35.426 155.107c-5.952 2.039-4.297 12.063-4.036 12.084a69.732 69.732 0 0 0 1.614 2.826c-.282-1.423 1.082-4.715 4.383-8.118 3.148-3.493 3.637-8.938-1.964-6.788l.003-.004Zm-16.902 6.667c-5.768 2.205-.056 8.521 4.859 7.788 4.841-.555 8.354-.305 9.548.504a63.508 63.508 0 0 1-1.809-2.719c-.152.191-7.062-7.458-12.598-5.573Zm14.226-15.611c-6.202 1.017-6.292 11.076-6.046 11.135a63.592 63.592 0 0 0 1.09 3.011c-.024-1.431 1.892-4.41 5.727-7.191 3.703-2.889 5.112-8.132-.77-6.955Zm-17.78 3.732c-6.052 1.209-1.506 8.323 3.45 8.407 4.856.25 8.264 1.066 9.291 2.045a61.363 61.363 0 0 1-1.298-2.938c-.173.167-5.66-8.434-11.442-7.514Zm16.645-12.958c-6.282-.028-8.055 9.837-7.83 9.927.164 1.045.351 2.09.566 3.129.219-1.403 2.614-4.004 6.858-6.094 4.137-2.216 6.403-7.136.406-6.962Zm-18.155.705c-6.167.184-2.877 7.934 1.993 8.833 4.744 1.049 7.961 2.413 8.808 3.542a68.318 68.318 0 0 1-.78-3.09c-.199.142-4.162-9.219-10.02-9.285Zm18.576-10.004c-6.192-1.073-9.59 8.375-9.378 8.493a68.6 68.6 0 0 0 .035 3.174c.45-1.34 3.245-3.504 7.777-4.854 4.45-1.49 7.504-5.976 1.566-6.813Zm-18.016-2.351c-6.116-.851-4.165 7.368.489 9.066 4.501 1.83 7.448 3.709 8.093 4.959a64.391 64.391 0 0 1-.253-3.174c-.219.118-2.565-9.795-8.326-10.851h-.004Zm20.011-6.82c-5.928-2.1-10.884 6.723-10.69 6.869a68.159 68.159 0 0 0-.5 3.149c.67-1.25 3.787-2.927 8.486-3.503 4.634-.726 8.417-4.681 2.704-6.515Zm-17.361-5.364c-5.885-1.868-5.368 6.639-1.065 9.097 4.13 2.573 6.72 4.927 7.146 6.275.066-1.063.16-2.125.281-3.184-.239.086-.87-10.16-6.361-12.185v-.003Zm7.683 6.118c-.146.08-.534-9.111 1.375-13.771 1.738-4.632 5.629-4.424 6.92-2.691 1.326 1.722-.02 4.899-1.676 7.274-1.826 2.216-6.723 9.077-6.619 9.188Z"
          fill="#16A34A"
        />
        <path
          d="M24.555 119.499s-.024.017-.038.024a.356.356 0 0 1-.4-.045.098.098 0 0 1-.02-.028c-.066-.069-.115-.125-.087-.257-.36-1.66-.24-9.868 1.402-13.875.857-2.281 2.391-3.743 4.21-4 1.308-.184 2.606.298 3.3 1.236 1.795 2.33-.825 6.462-1.669 7.674-1.78 2.16-6.233 8.406-6.563 9.062a.36.36 0 0 1-.132.209h-.003Zm3.495-16.806c-.708.517-1.444 1.392-2 2.875-1.506 3.677-1.561 10.136-1.457 12.584.4-.601 1.048-1.514 2.069-2.938 1.315-1.833 3.068-4.212 4.046-5.399 1.586-2.275 2.87-5.285 1.67-6.848-.552-.743-1.597-1.121-2.659-.969a3.723 3.723 0 0 0-1.666.695h-.003Zm69.788 68.863h-.652c2.197-13.872 11.592-25.813 24.561-31.199a.32.32 0 0 1 .42.174.32.32 0 0 1-.173.42c-12.731 5.285-21.962 16.993-24.156 30.601v.004Z"
          fill="#16A34A"
        />
        <path
          d="M106.641 161.871c-3.402-1.986-7.466 2.907-7.369 3.042a39.717 39.717 0 0 0-.673 1.924c.559-.715 2.672-1.42 5.636-1.25 2.944.059 5.72-1.941 2.409-3.712l-.003-.004Zm-10.079-5.274c-3.408-1.826-4.054 3.465-1.694 5.49 2.246 2.062 3.568 3.83 3.672 4.726.167-.664.347-1.32.545-1.969-.153.007.635-6.4-2.527-8.25l.004.003Zm13.213.34c-3.023-2.521-7.82 1.559-7.743 1.698a37.697 37.697 0 0 0-.979 1.75c.666-.597 2.86-.913 5.747-.236 2.884.57 5.942-.91 2.975-3.215v.003Zm-9.048-6.889c-3.051-2.371-4.554 2.698-2.562 5.077 1.871 2.403 2.881 4.35 2.839 5.236.271-.615.556-1.222.858-1.82-.15-.013 1.669-6.135-1.135-8.496v.003Zm12.947 2.573c-2.561-2.986-7.954.215-7.902.361a42.045 42.045 0 0 0-1.25 1.549c.753-.469 2.964-.403 5.692.75 2.742 1.052 5.997.108 3.46-2.66Zm-7.771-8.309c-2.613-2.844-4.932 1.889-3.363 4.563 1.447 2.677 2.121 4.757 1.933 5.621.368-.555.747-1.101 1.142-1.635-.149-.035 2.655-5.747.285-8.549h.003Zm12.343 4.698c-2.031-3.372-7.889-1.108-7.861-.958-.507.427-1.003.864-1.489 1.316.819-.337 2.985.1 5.484 1.694 2.526 1.497 5.9 1.104 3.862-2.052h.004Zm-6.268-9.493c-2.103-3.243-5.192 1.048-4.089 3.944.979 2.882 1.298 5.046.969 5.865a40.63 40.63 0 0 1 1.395-1.42c-.146-.056 3.582-5.229 1.721-8.389h.004Zm11.423 6.68c-1.437-3.666-7.639-2.399-7.628-2.246a39.83 39.83 0 0 0-1.694 1.052c.868-.194 2.936.594 5.133 2.583 2.242 1.896 5.661 2.066 4.189-1.389Zm-4.577-10.416c-1.527-3.553-5.338.177-4.741 3.222.476 3.01.42 5.201-.038 5.955a40.086 40.086 0 0 1 1.621-1.17c-.139-.08 4.449-4.573 3.158-8.004v-.003Zm.254 6.145c-.098-.038 4.091-3.986 7.076-4.989 2.905-1.073 4.398.854 4.106 2.173-.271 1.334-2.325 1.997-4.127 2.188-1.794.042-7.045.535-7.059.632l.004-.004Z"
          fill="#16A34A"
        />
        <path
          d="m119.033 142.135-.028-.007a.227.227 0 0 1-.142-.208c0-.007 0-.014.003-.021.007-.059.014-.104.087-.146.639-.851 4.571-4.157 7.136-5.021 1.429-.528 2.748-.399 3.616.354.625.545.927 1.358.767 2.07-.368 1.802-3.394 2.257-4.314 2.354-1.753.041-6.532.493-6.976.604a.213.213 0 0 1-.153.021h.004Zm9.381-5.23c-.535-.121-1.25-.111-2.18.233-2.356.795-5.435 3.413-6.549 4.466a73.437 73.437 0 0 1 2.235-.223c1.406-.128 3.249-.274 4.214-.295 1.725-.18 3.675-.805 3.921-2.014.125-.566-.121-1.215-.631-1.656a2.29 2.29 0 0 0-1.014-.504l.004-.007Zm-33.957 34.651h-.78c-7.101-10.39-9.07-23.748-5.075-35.803a.32.32 0 1 1 .61.201c-3.98 12.007-1.946 25.324 5.245 35.602Z"
          fill="#16A34A"
        />
        <path
          d="M94.967 161.26c-3.727 1.274-2.69 7.549-2.527 7.563.32.597.66 1.184 1.01 1.767-.177-.892.677-2.951 2.742-5.083 1.972-2.188 2.277-5.598-1.228-4.25l.003.003Zm-10.582 4.174c-3.61 1.382-.035 5.333 3.044 4.875 3.03-.347 5.23-.191 5.976.316a39.22 39.22 0 0 1-1.131-1.701c-.097.118-4.422-4.671-7.886-3.49h-.003Zm8.905-9.771c-3.883.635-3.938 6.934-3.786 6.969.212.632.441 1.26.684 1.885-.014-.896 1.183-2.76 3.585-4.5 2.319-1.809 3.2-5.09-.482-4.354Zm-11.129 2.333c-3.79.757-.944 5.209 2.159 5.261 3.04.156 5.171.666 5.817 1.281a36.456 36.456 0 0 1-.813-1.84c-.107.104-3.543-5.282-7.163-4.702Zm10.419-8.108c-3.932-.017-5.043 6.16-4.9 6.216.1.653.218 1.309.353 1.958.14-.878 1.635-2.507 4.294-3.812 2.589-1.386 4.008-4.466.253-4.358v-.004Zm-11.363.438c-3.862.114-1.8 4.965 1.25 5.528 2.97.656 4.984 1.51 5.515 2.215a37.528 37.528 0 0 1-.49-1.934c-.121.09-2.606-5.771-6.271-5.813l-.004.004Zm11.626-6.261c-3.877-.673-6 5.243-5.869 5.316-.01.664 0 1.323.021 1.987.281-.841 2.03-2.195 4.87-3.039 2.783-.93 4.695-3.739.978-4.264Zm-11.276-1.472c-3.828-.531-2.606 4.611.306 5.674 2.818 1.146 4.661 2.323 5.067 3.104-.07-.66-.121-1.323-.16-1.986-.135.073-1.606-6.132-5.213-6.792Zm12.529-4.267c-3.71-1.316-6.813 4.208-6.691 4.298a37.614 37.614 0 0 0-.313 1.973c.42-.785 2.37-1.83 5.31-2.195 2.902-.455 5.269-2.931 1.694-4.076Zm-10.866-3.358c-3.686-1.17-3.36 4.156-.666 5.694 2.585 1.612 4.206 3.084 4.473 3.928.042-.664.1-1.33.177-1.993-.15.055-.545-6.362-3.98-7.629h-.004Zm4.807 3.83c-.094.048-.334-5.702.86-8.622 1.09-2.899 3.523-2.767 4.332-1.684.83 1.076-.01 3.066-1.048 4.552-1.142 1.386-4.207 5.681-4.144 5.75v.004Z"
          fill="#16A34A"
        />
        <path
          d="M88.165 138.968s-.013.01-.024.014a.227.227 0 0 1-.25-.028.063.063 0 0 1-.014-.017c-.041-.045-.069-.08-.055-.16-.226-1.038-.15-6.177.878-8.684.534-1.427 1.496-2.344 2.634-2.504.82-.114 1.631.188 2.065.775 1.121 1.458-.517 4.045-1.044 4.805-1.115 1.354-3.901 5.264-4.11 5.674a.214.214 0 0 1-.083.128l.003-.003Zm2.187-10.518c-.44.323-.902.872-1.253 1.799-.944 2.302-.979 6.344-.913 7.875.25-.375.656-.948 1.295-1.837.822-1.146 1.92-2.635 2.534-3.382.992-1.423 1.797-3.309 1.044-4.285-.347-.465-1-.701-1.666-.607a2.32 2.32 0 0 0-1.044.434l.003.003Z"
          fill="#16A34A"
        />
        <path
          d="M130.724 34.174c-16.156 0-29.302 13.15-29.302 29.316v43.314h7.982V63.49c0-11.76 9.565-21.33 21.32-21.33s21.32 9.57 21.32 21.33v12.612l2.402 4.475h-2.402v4.014h7.983v-21.1c0-16.164-13.144-29.317-29.303-29.317Z"
          fill="#fff"
          stroke="#0C270F"
          strokeMiterlimit={10}
          strokeWidth={0.5}
        />
        <path
          d="M131.391 39.146c-14.181 0-25.717 11.542-25.717 25.73V98.41c0 2.938.503 5.761 1.412 8.393h2.319v-.726a23.194 23.194 0 0 1-1.302-7.667V64.876c0-12.848 10.447-23.3 23.288-23.3 12.841 0 23.288 10.452 23.288 23.3V84.59h2.429V64.876c0-14.188-11.536-25.73-25.717-25.73Z"
          fill="#0C270F"
        />
        <path
          d="M163.361 93.477h-60.834v58.418h60.834V93.477Z"
          fill="#0C270F"
          stroke="#0C270F"
          strokeMiterlimit={10}
          strokeWidth={0.5}
        />
        <path
          d="M151.592 93.477h-53.51v58.418h53.51V93.477Z"
          fill="#16A34A"
          stroke="#0C270F"
          strokeMiterlimit={10}
          strokeWidth={0.5}
        />
        <path
          d="M130.178 118.992a6.012 6.012 0 1 0-9.769 4.691v13.58h7.514v-13.58a5.993 5.993 0 0 0 2.252-4.691h.003Z"
          fill="#0C270F"
          stroke="#0C270F"
          strokeMiterlimit={10}
          strokeWidth={0.5}
        />
        <path
          d="m44.127 127.891-1.086 5.275-5.678 17.927c-.188.754-.43 1.49-.726 2.205l-4.248 12.435 1.756 1.114 8.462-12.761c.496-.75 1.013-1.305 1.423-2.104l7.587-13.073.562-.469 8.336 13.476c.372.455.673.962.903 1.504l6.039 14.274 3.352-.187-2.752-16.629a6.26 6.26 0 0 0-1.097-2.636l-9.35-18.198-.399-2.858-13.087.702.003.003Z"
          fill="#737373"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="m55.798 133.402.483-.427m-3.453 5.097 2.46-4.215"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="m55.32 108.703 7.631 5.743 9.92-5.906 1.651 2.441s-11.887 9.216-12.202 9.295c-.316.08-5.828-1.416-5.828-1.416l-1.176-10.153.003-.004Z"
          fill="#16A34A"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M44.221 107.019s-4.918.139-5.126.563c-.212.42.774 5.972 1.895 9.91 1.124 3.934 2.88 8.292 2.88 8.715 0 .424-.211 1.757.282 2.108.492.351 7.725.493 9.762.632 2.038.139 3.093-.983 3.301-1.757.212-.774-.562-3.302-.562-3.302s-.632-11.806-.701-12.931c-.07-1.125 0-1.476-.632-2.25-.632-.775-6.32-1.827-7.444-1.827-1.125 0-3.651.139-3.651.139h-.004Z"
          fill="#16A34A"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M50.78 110.189s2.714 11.226 3.228 15.997"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="m51.894 106.79.927 1.903-1.902-.733.975-1.17Z"
          fill="#16A34A"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="m50.235 109.182 1.66-2.392-2.052-.976.392 3.368Z"
          fill="#16A34A"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="m45.158 100.686.295 5.42 4.782 3.076.438-5.809-5.515-2.687Z"
          fill="#FEE2E2"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="m45.16 100.762.279 5.108 5.22-2.323.013-.174-5.449-2.656-.062.045Z"
          fill="#0C270F"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M50.77 94.241s1.17 1.903.975 2.344c-.194.44-.291.684-.145.781.145.097 1.756 1.514 1.658 1.854-.097.34-.926.782-.926.782s.378 4.055.135 4.201c-.243.146-4.428-.441-4.768-.587-.34-.145-1.951-1.757-2.489-2.489-.538-.733-1.27-2.587-1.27-3.664 0-1.076 1.12-3.368 3.366-3.76 2.246-.389 3.464.538 3.464.538Z"
          fill="#FEE2E2"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M49.941 100.2s.292.83 1.805.538m-2.634-4.202s.538-.684 1.464-.44"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M50.576 97.88c0 .257-.122.465-.267.465-.146 0-.268-.208-.268-.465s.122-.465.268-.465c.145 0 .267.208.267.465Z"
          fill="#0C270F"
        />
        <path
          d="m45.255 99.759.683-.098s-.926-.83-.489-1.27c.44-.442 1.756-1.073 1.61-1.612-.145-.538-1.561-1.416-.683-1.805.878-.39 6.295-.292 6.882-.49.586-.198.78-1.708-.781-2.344-1.562-.635-2.88-.635-2.88-.635s1.072-.587.586-.83c-.49-.243-3.953.243-5.956 1.17-2.002.927-2.88 2.295-2.731 3.466.146 1.17 2.002 4.493 2.197 4.639.194.145 1.562-.195 1.562-.195v.004Z"
          fill="#0C270F"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M45.737 100.019s-.194-1.27-1.319-1.465c-1.12-.195-1.343 1.184-1.003 1.864.34.684 1.833 1.212 2.273.966.441-.243.49-.389.49-.389"
          fill="#FEE2E2"
        />
        <path
          d="M45.737 100.019s-.194-1.27-1.319-1.465c-1.12-.195-1.343 1.184-1.003 1.864.34.684 1.833 1.212 2.273.966.441-.243.49-.389.49-.389"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M44.818 105.276c.243 0 4.394 2.15 4.394 2.15l1.023 1.757-5.709-2.393.292-1.514Z"
          fill="#16A34A"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="m44.817 105.276-1.221 1.757 4.345 2.538 1.267-2.145-4.39-2.15Z"
          fill="#16A34A"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="m67.46 167.698.19 3.948s4.137-.063 5.092.191c.954.253 3.054.191 4.137.128 0 0 .319-.382.319-.701 0-.32-1.336-.764-1.655-.955-.32-.191-2.673-.892-2.926-1.146-.254-.253-1.972-1.719-1.972-1.719l-3.182.254h-.004Zm-35.067-1.962-.656 1.007s-2.301 1.99-2.7 2.778c-.4.788-.715 2.913-.715 2.913s.277.365.916.389c.638.024 2.835-1.576 3.19-2.045.353-.469 1.113-2.618 1.35-2.952.235-.333.367-.982.367-.982l-1.756-1.115.004.007Z"
          fill="#0C270F"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M118.194 121.603h-6.522v14.424h6.522v-14.424Z"
          fill="#fff"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M119.776 121.603h-6.522v14.424h6.522v-14.424Zm-10.94 0h-6.521v8.083h6.521v-8.083Z"
          fill="#fff"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M110.422 121.603h-6.521v8.083h6.521v-8.083Z"
          fill="#fff"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M120.174 115.45H80.946c-1.704-5.354-6.712-9.233-12.63-9.233-7.32 0-13.254 5.938-13.254 13.261 0 7.323 5.935 13.261 13.254 13.261 6.202 0 11.405-4.261 12.852-10.015h39.003a3.635 3.635 0 0 0 0-7.271l.003-.003Zm-52.007 10.476a6.372 6.372 0 0 1 0-12.743 6.372 6.372 0 0 1 0 12.743Z"
          fill="#fff"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M54.32 116.523s.61-1.899.79-2.08c.181-.181 2.451-1.628 2.451-1.628s.469.138.132.559c-.337.42-1.645 1.35-1.645 1.35l-.514.962 1.718-.955 1.794-.559s.473.32.257.573c-.215.254-1.811.684-1.811.684l-1.25 1.094 1.742-.361 1.32.33s.128.378-.247.507c-.378.128-1.479-.094-1.479-.094l-1.075.371 2.058.556s.291.5-.302.524c-.594.025-2.038-.142-2.038-.142s-1.409 1.33-1.985 1.587c-.572.257-2.79.298-2.79.298l-.201-2.159 3.064-1.417h.01Z"
          fill="#FEE2E2"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M39.09 107.582s-1.294.187-1.662 1.434c-.367 1.246-1.905 15.629-1.905 15.629l15.93-4.542-.201-2.16-9.714.243 1.319-6.309"
          fill="#16A34A"
        />
        <path
          d="M39.09 107.582s-1.294.187-1.662 1.434c-.367 1.246-1.905 15.629-1.905 15.629l15.93-4.542-.201-2.16-9.714.243 1.319-6.309"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M41.538 118.186s-1.905 0-3.668 1.469"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M75.275 107.144s.688.285.872.476c.183.187.45.944.475 1.062.038.198-.097.428-.416.164-.32-.264-.639-.858-.639-.858l-.291-.84v-.004Z"
          fill="#FEE2E2"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M74.297 106.516s.812.406 1.024.677c.212.271.53 1.347.558 1.517.046.281-.114.611-.489.233-.375-.375-.753-1.226-.753-1.226l-.344-1.201h.004Z"
          fill="#FEE2E2"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M72.974 106.425s1.055-.069 1.326.091c.267.159.66 1.712.608 1.982-.053.268-.466-.069-.466-.069l-1.464-2.004h-.004Z"
          fill="#FEE2E2"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
        <path
          d="M72.058 106.641s.645-.268.913-.215c.267.052 1.183 1.184 1.128 1.451-.053.267-.698.267-.861.052-.16-.215-.538-.698-.538-.698l-.646-.59h.004Z"
          fill="#FEE2E2"
          stroke="#0C270F"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={0.5}
        />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M9 34h166v139H9z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
}
